export default "__VITE_ASSET__9871ac78__"